import { ReactComponent as IcProgressOff } from 'constants/icon/ic_progress_off.svg';
import { ReactComponent as IcProgressOn } from 'constants/icon/ic_progress_on.svg';
import { ReactComponent as IcProgressStick } from 'constants/icon/ic_progress_stick.svg';
import * as S from '../style';
import { Text } from 'components/Typography';
import moment from 'moment';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

export default function DeliveryProgressComponent({
  ...props
}: {
  progressStatus: any;
  now: string;
  s3Files: any;
  setS3Image: any;
}) {
  if (!props?.progressStatus) return <></>;
  const maxLength = Object.keys(props?.progressStatus)?.length;
  return (
    <S.DeliveryInfoContainerWrapper>
      {/* <S.DeliveryInfoContainerDragBar /> */}
      <S.DeliveryInfoContainer>
        {Object.keys(props?.progressStatus)?.map((progress: any, idx: any) => {
          let color = progress === props?.now ? '#1c48cd' : '#7D818D';
          let datetimeColor = progress === props?.now ? '#565B69' : '#8F96A9';
          let date = '';
          if (props?.progressStatus[progress]?.date) {
            date = moment(props.progressStatus[progress].date, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss');
          }
          return (
            <S.progressStep key={`${progress}-${idx}`}>
              <S.progressBar height={progress === 'completed' && props?.s3Files?.length ? '144px' : '87px'}>
                {progress === props?.now ? <IcProgressOn /> : <IcProgressOff />}
                {maxLength - 1 !== idx && <IcProgressStick />}
              </S.progressBar>
              <S.progressContentContainer>
                <S.progressTitle color={color}>{props?.progressStatus[progress].step}</S.progressTitle>
                <S.progressStatus color={color}>{props?.progressStatus[progress].status}</S.progressStatus>
                <S.progressDatetime color={datetimeColor}>{date}</S.progressDatetime>
                {progress === 'completed' && (
                  <SwiperSlideBox>
                    {props?.s3Files?.map((s3File: any, idx: any) => {
                      return (
                        <SwiperSlideImg
                          onClick={() => {
                            props.setS3Image(s3File);
                          }}
                          src={s3File}
                          alt={`PoD image${idx}`}
                        />
                      );
                    })}
                  </SwiperSlideBox>
                )}
              </S.progressContentContainer>
            </S.progressStep>
          );
        })}
      </S.DeliveryInfoContainer>
    </S.DeliveryInfoContainerWrapper>
  );
}

export const SwiperSlideImg = styled.img`
  width: 60px;
  height: 60px;
  margin-top: 8px;
  margin-bottom: 8px;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  margin-right: 8px;
`;

export const SwiperSlideBox = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #ccc;
  }
`;
